export const updateCssVars = () => {
  const header = document.querySelector('.app-header') as HTMLElement | null;
  const headerRoot = document.querySelector('.app-header-root') as HTMLElement | null;

  if (!header || !headerRoot) return;

  document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
  document.body.style.setProperty('--header-total-height', `${headerRoot.offsetHeight}px`);
  document.body.style.setProperty('--bar-height', `${headerRoot.offsetHeight - header.offsetHeight}px`);
};
